<template>
	<div
		v-show="isPreviewing"
		:id="`campaign-${slug}`"
		class="campaign-inline-preview"
		:class="{ 'is-loading': isOpening }"
		@click="maybeClose"
	>
		<div :id="`om-${slug}-holder`" class="campaign-inline-preview__inner">
			<svg-loading />
		</div>
	</div>
</template>

<script>
import { templatePreviewItem } from 'optinmonster-js-library/src/vue/templates/mixins/templatePreviewItem';

export default {
	mixins: [templatePreviewItem],
	props: {
		template: {
			type: Object,
			default: () => {},
		},
	},
};
</script>
